<template>
  <div class="top_box">
    <div class="top_left">
      <div class="logoA_img" style="display: grid;">
        <el-image
          v-if="agent_info.logo"
          style="width: 45px; height: 45px;margin-right: 13px;"
          :src="agent_info?agent_info.logo:require('../images/yixiang_logo.png')"
          fit="cover"
        />

        <img v-else class="logo_img_cover" :src="agent_info?agent_info.logo:require('../images/yixiang_logo.png')" alt="">
      </div>
      <div class="name">
        {{ agent_info?agent_info.name:'易象' }}
      </div>
      <div class="blank" />
      <div class="top_title">
        代理商
      </div>
    </div>
    <div class="topIcon" @click="show_menu = !show_menu">
      <i class="el-icon-s-unfold" />
    </div>
    <el-drawer title="" size="50%" :visible.sync="show_menu" direction="ltr" append-to-body>
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="" @select="handleSelect">
        <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
        <el-menu-item v-for="(item, index) in menuItems" v-if="item.condition" :key="index" :index="item.index">
          {{ item.label }}
          <div class="bor" />
        </el-menu-item>
      </el-menu>
    </el-drawer>
    <div class="top_box_list">
      <el-menu class="big_menu" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
        <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
        <el-menu-item v-for="(item, index) in menuItems" v-if="item.condition" :key="index" :index="item.index">
          {{ item.label }}
          <div class="bor" />
        </el-menu-item>
      </el-menu>
      <el-dropdown style="margin-right: 35px;" @command="handleCommand">
        <span class="el-dropdown-link" style="cursor:pointer;margin-bottom: 6px;"> 我的账户<i class="el-icon-caret-bottom" /> </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="b">
            修改密码
          </el-dropdown-item>
          <el-dropdown-item command="a">
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { removeToken, removeType, getAuthority, removeAuthority, getSid, removeAccountId } from '@/utils/auth.js'
export default {
  data() {
    return {
      activeIndex: this.$route.path,
      worker_type: localStorage.getItem('_yixiang_agent_worker_type'),
      activeIndex2: '1',
      super_admin: getAuthority(),
      getSid: getSid(),
      agent_info: localStorage.getItem('agent_info') ? JSON.parse(localStorage.getItem('agent_info')) : '',
      agent_id: localStorage.getItem('agent_id'),
      show_menu: false,
      menuItems: [
        {
          index: '/index/body1',
          label: '数据中心',
          condition: true
        },
        {
          index: '/index/management',
          label: '商户管理',
          condition: true
        },
        {
          index: '/index/Order',
          label: '商户订单',
          condition: localStorage.getItem('_yixiang_agent_worker_type') == 0
        },
        {
          index: '/index/copyright',
          label: '版权页设计',
          condition: localStorage.getItem('_yixiang_agent_worker_type') == 0
        },
        {
          index: '/index/agent',
          label: '下级代理',
          condition: (getSid() == 0 || getSid() == 1) && localStorage.getItem('_yixiang_agent_worker_type') == 0
        },
        {
          index: '/index/page_component',
          label: '界面组件',
          condition: localStorage.getItem('agent_id') == 1
        }
      ]
    }
  },
  mounted() {
    const agent_info = this.agent_info
    console.log(agent_info)
    if (agent_info && agent_info.logo) {
      const link = document.querySelector("link[rel*='icon']")
      // link.href = agent_info.logo
      link.href = 'data:,'
      document.title = agent_info.name + '代理后台'
    } else {
      const link = document.querySelector("link[rel*='icon']")
      link.href = 'favicon.ico'
      document.title = '易象代理后台'
    }
  },
  methods: {

    checkCondition(item, getSid, worker_type, agent_id) {
      if (!item.condition) return true
      if (item.condition === 'worker_type') {
        return worker_type === item.conditionValue
      }
      if (item.condition === 'getSid') {
        return item.conditionValue.includes(getSid)
      }
      if (item.condition === 'agent_id') {
        return agent_id === item.conditionValue
      }
      return false
    },
    handleSelect(path, keyPath) {
      if (path == this.$route.path) {
        return
      }
      this.$router.push(path)
      this.show_menu = false
    },

    handleCommand(command) {
      console.log(command)
      const agent_info = JSON.parse(JSON.stringify(this.agent_info))
      if (command == 'a') {
        removeToken()
        removeType()
        removeAuthority()
        removeAccountId()
        this.$root.$children[0].title = ''

        const path = agent_info && agent_info.id ? '/login?id=' + agent_info.id : '/login'
        this.$router.push(path)
        // this.$router.push('/login')
      }
      if (command == 'b') {
        this.$router.push('/index/update_password')
      }
    }
  }
}
</script>

<style scoped>

.topBar {
  position: relative;
  right: 0;
  height: 60px;
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;
  max-width: 1200px;
  left: 50%;
  margin-left: -600px;
  height: 88px;
  margin-right: 100px;
}

.top_left {
  position: relative;
  float: left;
  display: flex;
  align-items: center;
}
.top_title {
  font-size: 16px;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(73, 73, 73, 1);
}

.logoA_img img {
  width: 31px;
  height: 35px;
}

.blank {
  position: relative;
  width: 1px;
  height: 17px;
  background: rgba(216, 216, 216, 1);
  float: left;
  margin: 0 24px;
}

.logo_img_cover {
  width: 31px;
  height: 35px;
  margin-right: 16px;
}

.name {
  font-size: 26px;
}
.top_box .tarbarName {
  width: 110px;
  font-size: 14px;
  cursor: pointer;
}
.top_box .is-active .bor {
  width: 37px;
  background: #ff5f2e;
  height: 3px;
  margin: 0 auto;
}

.top_box .el-menu--horizontal > .el-menu-item.is-active {
  border: 0px;
  color: #ff5f2e !important;
}

.top_box .el-menu-item {
  transition: none !important;
}

.top_box .el-menu--horizontal > .el-menu-item {
  height: 32px;
  line-height: 32px;
  margin-top: -7px;
}

.top_box .el-menu.el-menu--horizontal {
  border-bottom: none;
}

.top_box .el-menu.el-menu--horizontal {
  float: right;
  right: 8px;
  /* width: 411px; */
}

.top_box .el-menu-item.is-active {
  background-color: #fff !important;
}

.top_box .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 32px;
  line-height: 32px;
}

.top_box .el-menu--horizontal > .el-submenu {
  margin-top: -7px;
}

.top_box .el-dropdown {
  line-height: 18px;
  color: #494949;
  margin-bottom: 6px;
}

.top_box .el-menu--horizontal > .el-menu-item {
  color: #494949;
}
.top_box .top_box_list{
  display: flex;
}
.topIcon{
  font-size: 30px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  display: none;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #494949;
  margin-left: 10px;
}
</style>
